export default {
  name: 'UserProfileModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    is_loading: {
      type: Boolean,
      default: false
    },
    is_editing: {
      type: Boolean,
      default: false
    },
    is_saving: {
      type: Boolean,
      default: false
    },
    can_edit: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    },
    save_error: {
      type: String,
      default: ''
    },
    profile: {
      type: Object,
      default: () => ({})
    },
    edit_form: {
      type: Object,
      default: () => ({
        first_name: '',
        last_name: '',
        phone_number: ''
      })
    }
  },
  emits: [
    'close',
    'open-edit',
    'save',
    'update:first-name',
    'update:last-name',
    'update:phone-number',
    'sanitize-name',
    'sanitize-phone'
  ],
  methods: {
    close_modal() {
      this.$emit('close');
    },
    open_edit() {
      this.$emit('open-edit');
    },
    save_changes() {
      this.$emit('save');
    },
    update_first_name(event) {
      this.$emit('update:first-name', event?.target?.value || '');
      this.$emit('sanitize-name', 'first_name');
    },
    update_last_name(event) {
      this.$emit('update:last-name', event?.target?.value || '');
      this.$emit('sanitize-name', 'last_name');
    },
    update_phone_number(event) {
      this.$emit('update:phone-number', event?.target?.value || '');
      this.$emit('sanitize-phone');
    }
  }
};
